import * as THREE from "three";
import { DBEntity } from "./DBEntity";

/**
 * mesh的抽象实体
 */
export class DbMesh extends DBEntity {
  constructor(params: {
    id: string;
    layerId: string;
    blockId: string;
    vertexs: Float32Array;
    indexes: Int32Array;
    root_reference_id?: string;
    block_path?: Uint8Array[] | string;
    root_block_id?: string;
    extend_id?: string;
    color?: number;
    userData?: any;
    entity_id?: string;
    source_id?: string;
  }) {
    super(params);
    this.vertexs = params.vertexs;
    this.indexes = params.indexes;
    this.color = params.color;
  }
  vertexs: Float32Array;
  indexes: Int32Array;
  count: number = 0;
  sphere: THREE.Sphere | undefined;
  box: THREE.Box3 | undefined;
  index?: number;
  radiusCp?: number;
  color?: number;
  /**
   *
   * @param mesh 克隆方法，用于解决woker传递过来得对象没有属性了
   */
  static clone(mesh: DbMesh): DbMesh {
    let newMesh: DbMesh = new DbMesh({
      id: mesh.id,
      blockId: mesh.blockId,
      indexes: new Int32Array([...mesh.indexes]),
      layerId: mesh.layerId,
      vertexs: new Float32Array([...mesh.vertexs]),
      extend_id: mesh.extend_id,
      source_id: mesh.source_id,
      entity_id: mesh.entity_id,
    });
    newMesh.sphere = mesh.sphere;
    newMesh.box = mesh.box;
    newMesh.root_reference_id = mesh.root_reference_id;
    newMesh.block_path = mesh.block_path;
    newMesh.root_block_id = mesh.root_block_id;
    newMesh.color = mesh.color;
    return newMesh;
  }
  get V3Points() {
    let points = [];
    for (let index = 0; index < this.vertexs.length; index += 3) {
      points.push(
        new THREE.Vector3(
          this.vertexs[index],
          this.vertexs[index + 1],
          this.vertexs[index + 2]
        )
      );
    }
    return points;
  }
  getBoundingBox() {
    this.box = new THREE.Box3();
    this.box.setFromPoints(this.V3Points);
    return this.box;
  }
  getBoundingSphere() {
    this.sphere = new THREE.Sphere();
    this.sphere.setFromPoints(this.V3Points);
    return this.sphere;
  }
}
